import './components/calculators/format';
import './components/calculators/input';

// =====================================================================
//  SST — interactivity layer
//  Static markup lives in page-calculator-sst.php.
// =====================================================================
(function () {
  const fmt = Calc.format;

  // SST math — kept local (finance.js is for SHARED formulas only).
  //   Add SST (exclusive):  base = amount;      tax = base × r;   total = base + tax
  //   Remove SST (inclusive): total = amount;   base = total / (1+r);  tax = total − base
  function computeSST(amount, ratePct, inclusive) {
    const a = amount || 0;
    const r = (ratePct || 0) / 100;
    let base, tax, total;
    if (inclusive) {
      total = a;
      base = (1 + r) !== 0 ? a / (1 + r) : a;
      tax = total - base;
    } else {
      base = a;
      tax = a * r;
      total = base + tax;
    }
    return { base, tax, total, rate: ratePct || 0 };
  }

  const REF_AMOUNTS = [100, 200, 500, 1000, 2000, 5000, 10000];
  const REF_RATES = [5, 6, 8, 10];

  const state = {
    amount: 1000,
    type: 'service',      // 'sales' | 'service'
    salesRate: 10,        // last-selected rate per type
    serviceRate: 8,
    rate: 8,              // active rate (mirrors the active type's rate)
    dir: 'add',           // 'add' (exclusive) | 'remove' (inclusive)
    activeTab: 'breakdown',
  };

  const setText = (id, val) => {
    const el = document.getElementById(id);
    if (el) el.textContent = val;
  };
  const toggleAll = (sel, hide) => {
    document.querySelectorAll(sel).forEach(el => el.classList.toggle('d-none', hide));
  };
  const syncInput = (id, val) => Calc.input.syncValue(id, val);

  function updateStatBand() {
    const s = computeSST(state.amount, state.rate, state.dir === 'remove');
    setText('sst-stat-base',  fmt.money(s.base, 0));
    setText('sst-stat-rate',  `${state.rate}%`);
    setText('sst-stat-tax',   fmt.money(s.tax, 0));
    setText('sst-stat-total', fmt.money(s.total, 0));
  }

  function updateBreakdown() {
    const s = computeSST(state.amount, state.rate, state.dir === 'remove');
    setText('sst-r-amount', fmt.money(state.amount));
    setText('sst-r-rate',   `${state.rate}%`);
    setText('sst-r-base',   fmt.money(s.base));
    setText('sst-r-tax',    fmt.money(s.tax));
    setText('sst-r-total',  fmt.money(s.total));
  }

  function updateReferenceGrid() {
    const tbody = document.getElementById('sst-grid-tbody');
    if (!tbody) return;
    tbody.innerHTML = REF_AMOUNTS.map(amt => {
      const isHighRow = amt === state.amount;
      const cells = REF_RATES.map(rate => {
        const tax = amt * (rate / 100);
        const isHighCol = rate === state.rate;
        return `<td class="${isHighCol ? 'highlight-col' : ''}">${fmt.number(tax, 0)}</td>`;
      }).join('');
      return `<tr class="${isHighRow ? 'highlight' : ''}"><th>RM ${amt.toLocaleString()}</th>${cells}</tr>`;
    }).join('');
  }

  function refresh() {
    syncInput('sst-amount-input', state.amount);

    const isService = state.type === 'service';
    const isRemove  = state.dir === 'remove';

    // Amount label + type/direction wording variants (variants live in HTML).
    toggleAll('.sst-amount-label-add',    isRemove);
    toggleAll('.sst-amount-label-remove', !isRemove);
    toggleAll('.sst-type-sales',    isService);
    toggleAll('.sst-type-service', !isService);
    toggleAll('.sst-type-hint-sales',    isService);
    toggleAll('.sst-type-hint-service', !isService);
    toggleAll('.sst-dir-hint-add',    isRemove);
    toggleAll('.sst-dir-hint-remove', !isRemove);

    // Show the rate button group for the active tax type.
    toggleAll('#sst-rate-sales',   isService);
    toggleAll('#sst-rate-service', !isService);

    // Active-button styling.
    document.querySelectorAll('#sst-type-tabs button').forEach(btn => {
      const active = btn.dataset.type === state.type;
      btn.classList.toggle('btn-primary', active);
      btn.classList.toggle('btn-outline-primary', !active);
    });
    document.querySelectorAll('#sst-dir-tabs button').forEach(btn => {
      const active = btn.dataset.dir === state.dir;
      btn.classList.toggle('btn-primary', active);
      btn.classList.toggle('btn-outline-primary', !active);
    });
    const activeGroup = isService ? '#sst-rate-service' : '#sst-rate-sales';
    document.querySelectorAll(`${activeGroup} button`).forEach(btn => {
      const active = +btn.dataset.rate === state.rate;
      btn.classList.toggle('btn-primary', active);
      btn.classList.toggle('btn-outline-primary', !active);
    });

    updateStatBand();
    if (state.activeTab === 'breakdown') updateBreakdown();
    else updateReferenceGrid();
  }

  function activateTab(tabId) {
    state.activeTab = tabId;
    document.querySelectorAll('#sst-tabs .btn-tab').forEach(btn => {
      btn.classList.toggle('active', btn.dataset.tab === tabId);
    });
    document.querySelectorAll('.tab-panel').forEach(panel => {
      panel.classList.toggle('d-none', panel.id !== `sst-tab-${tabId}`);
    });
    if (tabId === 'breakdown') updateBreakdown();
    else updateReferenceGrid();
  }

  function bindEvents() {
    ['input', 'change'].forEach(evt => document.addEventListener(evt, (e) => {
      if (e.target.id === 'sst-amount-input') {
        state.amount = Calc.input.getValue(e.target) || 0;
        refresh();
      }
    }));

    document.querySelectorAll('#sst-type-tabs button').forEach(btn => {
      btn.addEventListener('click', () => {
        state.type = btn.dataset.type;
        state.rate = state.type === 'service' ? state.serviceRate : state.salesRate;
        refresh();
      });
    });

    document.querySelectorAll('#sst-rate-sales button, #sst-rate-service button').forEach(btn => {
      btn.addEventListener('click', () => {
        const rate = +btn.dataset.rate;
        state.rate = rate;
        if (state.type === 'service') state.serviceRate = rate; else state.salesRate = rate;
        refresh();
      });
    });

    document.querySelectorAll('#sst-dir-tabs button').forEach(btn => {
      btn.addEventListener('click', () => { state.dir = btn.dataset.dir; refresh(); });
    });

    document.querySelectorAll('#sst-tabs .btn-tab').forEach(btn => {
      btn.addEventListener('click', () => activateTab(btn.dataset.tab));
    });
  }

  document.addEventListener('DOMContentLoaded', () => {
    bindEvents();
    refresh();
  });
})();
